
import { Contact } from 'lucide-react';
import type { AccountSettingsForm } from '@/lib/painel-account-settings';
import { BIO_MAX_LENGTH } from '@/lib/painel-account-settings';
import {
  AccountField,
  AccountSettingsCard,
  accountInputClass,
  accountTextareaClass,
} from './account-settings-shared';

type PersonalInfoPatch = Pick<
  AccountSettingsForm,
  'firstName' | 'lastName' | 'username' | 'email' | 'bio'
>;

type PersonalInfoCardProps = PersonalInfoPatch & {
  onChange: (patch: Partial<PersonalInfoPatch>) => void;
  delay?: number;
};

export function PersonalInfoCard({
  firstName,
  lastName,
  username,
  email,
  bio,
  onChange,
  delay = 0,
}: PersonalInfoCardProps) {
  const bioLength = bio.length;

  return (
    <AccountSettingsCard
      title="Informações pessoais"
      description="Atualize como você aparece no painel e nas comunicações internas."
      icon={Contact}
      accentClass="bg-cyan-500/15 text-cyan-300 ring-cyan-400/25"
      delay={delay}
    >
      <div className="grid gap-5 md:grid-cols-2">
        <AccountField id="account-first-name" label="Nome">
          <input
            id="account-first-name"
            value={firstName}
            onChange={(e) => onChange({ firstName: e.target.value })}
            className={accountInputClass}
            placeholder="Seu nome"
            autoComplete="given-name"
          />
        </AccountField>

        <AccountField id="account-last-name" label="Sobrenome">
          <input
            id="account-last-name"
            value={lastName}
            onChange={(e) => onChange({ lastName: e.target.value })}
            className={accountInputClass}
            placeholder="Seu sobrenome"
            autoComplete="family-name"
          />
        </AccountField>

        <AccountField
          id="account-username"
          label="Nome de usuário"
          hint="Usado para login e identificação interna."
        >
          <input
            id="account-username"
            value={username}
            onChange={(e) => onChange({ username: e.target.value })}
            className={accountInputClass}
            placeholder="usuario"
            autoComplete="username"
          />
        </AccountField>

        <AccountField id="account-email" label="E-mail">
          <input
            id="account-email"
            type="email"
            value={email}
            onChange={(e) => onChange({ email: e.target.value })}
            className={accountInputClass}
            placeholder="voce@ajuda"
            autoComplete="email"
          />
        </AccountField>

        <AccountField
          id="account-bio"
          label="Biografia"
          className="md:col-span-2"
          hint={`${bioLength}/${BIO_MAX_LENGTH} caracteres`}
        >
          <textarea
            id="account-bio"
            value={bio}
            maxLength={BIO_MAX_LENGTH}
            onChange={(e) => onChange({ bio: e.target.value })}
            className={accountTextareaClass + ' min-h-[120px] resize-y'}
            placeholder="Uma breve descrição sobre você e seu papel na equipe…"
          />
        </AccountField>
      </div>
    </AccountSettingsCard>
  );
}
